import { Linking } from 'react-native';
import * as WebBrowser from 'expo-web-browser';

/**
 * L'annonce s'ouvre dans le navigateur intégré, pour toutes les sources. Par Linking, l'adresse
 * France Travail est un lien universel de leur application : elle s'ouvrait à sa place, page vide
 * (retour de test sur iPhone, 03/10/2026). Repli sur Safari si le navigateur intégré refuse.
 */
/**
 * SEULS `http:` ET `https:` S'OUVRENT. L'adresse vient de l'employeur ou de son partenaire (contenu
 * tiers) : le repli `Linking.openURL` acceptait un `tel:`, un `sms:` ou le schéma d'une autre
 * application. Le serveur filtre déjà à la normalisation (`urlHttp`), mais ce filtre ne protège ni le
 * cache de 12 h, ni les aperçus déjà enregistrés dans « Sauvegardées » : la dernière barrière est ici,
 * là où l'adresse s'ouvre.
 */
export function adresseOuvrable(url: unknown): url is string {
  if (typeof url !== 'string') return false;
  try {
    const { protocol } = new URL(url.trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

export async function ouvrirAnnonce(url: string): Promise<void> {
  if (!adresseOuvrable(url)) return;
  try {
    await WebBrowser.openBrowserAsync(url);
  } catch {
    await Linking.openURL(url).catch(() => undefined);
  }
}
